export default __webpack_public_path__ + "static/media/amazing_acai.ca4d7e14.png";